/**
 * Copyright © Veeam Software Group GmbH.
 */

import { createContext } from 'react';

import type { JobsOverviewStore } from './jobs-overview-store';

export const JobsOverviewStoreContext = createContext<JobsOverviewStore>({} as JobsOverviewStore);
